// extracted by mini-css-extract-plugin
export var challenge = "Grid_ImageLeft_ContentRight-module--challenge--23c1d";
export var image = "Grid_ImageLeft_ContentRight-module--image--13dbc";